import { axiosInstance } from '../Config/axios';

const USERS_GAP = 'v1/users/';
const USERS_URL = 'v1/access/users/';
const USERS_DELETED_URL = 'v1/access/users-deleted/';

// VISTA GAP
export const getGapUsers = async () => {
  try {
    const response = await axiosInstance.get(USERS_GAP);
    return response.data;
  } catch (error) {
    console.error("Error al obtener los usuarios", error);
    throw error;
  }
};

export const getUserById = async (id) => {
  try {
    const response = await axiosInstance.get(`${USERS_URL}${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el usuario ${id}`, error);
    throw error;
  }
};

// VISTA SEGURIDAD
export const getUsers = async () => {
  try {
    const response = await axiosInstance.get(USERS_URL);
    return response.data;
  } catch (error) {
    console.error("Error al obtener los usuarios", error);
    throw error;
  }
};
// Función para crear un nuevo usuario (POST)
export const createUser = async (userData) => {
  try {
    const response = await axiosInstance.post(USERS_URL, userData);
    return response.data;
  } catch (error) {
    console.error('Error al crear el usuario:', error);
    throw error;
  }
};

// Función para actualizar un usuario (PUT)
export const updateUser = async (id, userData) => {
  try {
    const response = await axiosInstance.put(`${USERS_URL}${id}/`, userData);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar el usuario:', error);
    throw error;
  }
};

// Función para eliminar un usuario (DELETE)
export const deleteUser = async (id) => {
  try {
    await axiosInstance.delete(`${USERS_URL}${id}/`);
  } catch (error) {
    console.error('Error al eliminar el usuario:', error);
    throw error;
  }
};

// Función para listar los usuarios eliminados (GET)
export const getUsersDeleted = async () => {
  try {
    const response = await axiosInstance.get(USERS_DELETED_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los usuarios eliminados:', error);
    throw error;
  }
};

// Obtener una activo eliminado por código (GET)
export const getUserDeletedByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${USERS_DELETED_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el usuario eliminado con código ${code}:`, error);
    throw error;
  }
};

// Restablecer usuarios (POST)
export const resetUser = async (userId) => {
  try {
    const response = await axiosInstance.post('/v1/access/user-reactivate/', {
      user_id: userId
    });
    return response.data;
  } catch (error) {
    console.error('Error al reactivar el usuario:', error);
    throw error;
  }
};